module.exports = __webpack_public_path__ + "static/img/declaration-cn-card-active.2cdc5a51.svg";